import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:3001/";

export const getTenants = async (token, data) => {
  const url = `${apiUrl}api/tenants`;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
    params: { ...data },
  };
  const res = await axios.get(url, config);
  return res.data;
};

export const getTenantDetails = async (token, data) => {
  const url = `${apiUrl}api/tenants/details`;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
    params: { ...data },
  };
  const res = await axios.get(url, config);
  return res.data;
};

export const getTenantUsers = async (token, data) => {
  const url = `${apiUrl}api/tenants/users`;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
    params: { ...data },
  };
  const res = await axios.get(url, config);
  return res.data;
};

export const addTenantUser = async (token, data) => {
  const url = `${apiUrl}api/tenants/users`;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  const res = await axios.post(url, { ...data }, config);
  return res.data;
};

export const editTenantUser = async (token, userId, data) => {
  const url = `${apiUrl}api/tenants/users/${userId}`;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  const res = await axios.put(url, { ...data }, config);
  return res.data;
};

export const resetUserPassword = async (token, data) => {
  const url = `${apiUrl}api/tenants/trigger-password-reset`;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  const res = await axios.post(url, { ...data }, config);
  return res.data;
};

export const getSubscriptionPlans = async (token) => {
  const url = `${apiUrl}api/tenants/subscription-plans`;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  const res = await axios.get(url, config);
  return res.data;
};

export const updateSubscription = async (token, accountId, data) => {
  const url = `${apiUrl}api/tenants/subscription/${accountId}`;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  const res = await axios.put(url, { ...data }, config);
  return res.data;
};

export const convertTrialToPaid = async (token, accountId, data) => {
  const url = `${apiUrl}api/tenants/convert-trial-to-paid`;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  const res = await axios.post(url, { accountId, ...data }, config);
  return res.data;
};

export const extendTrial = async (token, accountId, data) => {
  const url = `${apiUrl}api/tenants/extend-trial`;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  const res = await axios.post(url, { accountId, ...data }, config);
  return res.data;
};

export const checkSalespersonUser = async (token, data) => {
  const url = `${apiUrl}api/tenants/salespeople`;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
    params: { ...data },
  };
  const res = await axios.get(url, config);
  return res.data;
};

export const getSalespeople = async (token) => {
  const url = `${apiUrl}api/manage/salespeople`;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  const res = await axios.get(url, config);
  return res.data;
};

export const updateQuestion = async (token, questionId, data) => {
  const url = `${apiUrl}api/questions/update-one`;
  //TODO: AUTH
  // const config = {
  //   headers: { Authorization: `Bearer ${token}` }
  // };
  const res = await axios.put(
    url,
    {
      questionId,
      question: data.question,
      type: data.type,
      active: data.active,
      day: data.day,
      requestingUserId: data.requestingUserId,
    }
    // config
  );
  return res.data;
};

export const provisionTenant = async (token, data) => {
  const url = `${apiUrl}api/tenants`;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  const res = await axios.post(url, { ...data }, config);
  return res.data;
};
export const addLead = async (token, data) => {
  const url = `${apiUrl}api/manage/new-lead`;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  const res = await axios.post(url, { ...data }, config);
  return res.data;
};
export const addNote = async (token, data) => {
  const url = `${apiUrl}api/manage/new-note`;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  const res = await axios.post(url, { ...data }, config);
  return res.data;
};
export const getLeads = async (token, data) => {
  const url = `${apiUrl}api/manage/leads`;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
    params: { ...data },
  };
  const res = await axios.get(url, config);
  return res.data;
};

export const getNotes = async (token, data) => {
  const url = `${apiUrl}api/manage/notes`;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
    params: { ...data },
  };
  const res = await axios.get(url, config);
  return res.data;
};

export const updateLead = async (token, leadId, data) => {
  const url = `${apiUrl}api/manage/leads/${leadId}`;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  const res = await axios.put(url, { ...data }, config);
  return res.data;
};

export const convertLeadToTrial = async (token, data) => {
  const url = `${apiUrl}api/manage/convert-lead-to-trial`;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  const res = await axios.post(url, { ...data }, config);
  return res.data;
};

export const triggerUpdateEmail = async (data) => {
  const url = `${apiUrl}api/tenants/trigger-password-reset`;
  const config = {
    // headers: { Authorization: `Bearer ${token}` }
  };
  const res = await axios.post(url, { ...data }, config);
  return res.data;
};

// Billing seeding functions
export const seedSubscriptionPlans = async (token) => {
  const url = `${apiUrl}api/billing/subscription-plans/seed`;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  const res = await axios.post(url, {}, config);
  return res.data;
};

export const seedAllBillingData = async (token) => {
  const url = `${apiUrl}api/billing/seed-all`;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  const res = await axios.post(url, {}, config);
  return res.data;
};

// Subscription Plans Management (Admin only)
export const getAllPlans = async (token) => {
  const url = `${apiUrl}api/tenants/plans`;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  const res = await axios.get(url, config);
  return res.data;
};

export const getSinglePlan = async (token, planId) => {
  const url = `${apiUrl}api/tenants/plans/${planId}`;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  const res = await axios.get(url, config);
  return res.data;
};

export const createPlan = async (token, data) => {
  const url = `${apiUrl}api/tenants/plans`;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  const res = await axios.post(url, { ...data }, config);
  return res.data;
};

export const updatePlan = async (token, planId, data) => {
  const url = `${apiUrl}api/tenants/plans/${planId}`;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  const res = await axios.put(url, { ...data }, config);
  return res.data;
};

export const deletePlan = async (token, planId) => {
  const url = `${apiUrl}api/tenants/plans/${planId}`;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  const res = await axios.delete(url, config);
  return res.data;
};
